module.exports = __webpack_public_path__ + "static/media/madison.84870e65.jpg";